import script from "./VitaPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaPopup.vue?vue&type=script&lang=ts&setup=true"

import "./VitaPopup.vue?vue&type=style&index=0&id=349c78ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-349c78ae"]])

export default __exports__